import { firebaseConfig } from './firebaseConfig';

const BASE =
  `https://australia-southeast1-${firebaseConfig.projectId}.cloudfunctions.net`;

export const FUNCTION_URLS = {
  gemini: process.env.GEMINI_PROXY_URL || `${BASE}/gemini`,
  geminiStream: `${BASE}/geminiStream`,
  queryInventory: `${BASE}/queryInventory`,
backfillEmbeddings: `${BASE}/backfillEmbeddings`,
  createCheckout: `${BASE}/createCheckoutSession`,
  createPortal: `${BASE}/createPortalSession`,
  cancelSubscription: `${BASE}/cancelSubscription`,
  mapImportFields: `${BASE}/mapImportFields`,
  commitImport: `${BASE}/commitImport`,
  submitFeedback: `${BASE}/submitFeedback`,
  linkRevenueCatUser: `${BASE}/linkRevenueCatUser`,
} as const;
